import React, { useState } from 'react'
import { authFetch } from '../services/authAPI';
import Modal from '../components/Modal';
import Field from '../components/Field';
import TextArea from '../components/TextArea';
import { PDFDownloadLink } from '@react-pdf/renderer';
import moment from 'moment';
import "moment/locale/fr";
import LabelDocument from '../components/Label';
import RouteReportDocument from '../components/RouteReport';
import Loading from '../components/Loading';



export default function LogisticPage() {

    const API_URL = `${process.env.REACT_APP_API_URL}/api/`;

    const [containersInput, setContainersInput] = useState("");
    const [containers, setContainers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [type, setType] = useState("bag");
    const [date, setDate] = useState(moment().format("YYYY-MM-DD"));

    // États temporaires pour le modal (ne modifient pas le tableau en arrière-plan)
    const [modalType, setModalType] = useState("bag");
    const [modalDate, setModalDate] = useState(moment().format("YYYY-MM-DD"));
    const [modalContainersInput, setModalContainersInput] = useState("");
    

    const TYPE_LABELS = {
        locker: "consigne",
        parcel_shop: "commerce"
    };

    function handleOpenModal() {
        setModalType(type);
        setModalDate(date);
        setModalContainersInput(containersInput);
        setShowModal(true);
    }

    async function handleSubmit(){
        setLoading(true);
        setError(null);
        const submittedType = modalType;
        const submittedDate = modalDate;
        const containerList = modalContainersInput
            .split("\n")
            .map(line => line.trim())
            .filter(line => line !== "");

        // Appliquer les valeurs du modal
        setType(submittedType);
        setDate(submittedDate);
        setContainersInput(modalContainersInput);

        try {
            const requests = [
                authFetch(API_URL + "v2/logistics/containers", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        date: submittedDate,
                        type: submittedType,
                        containers: containerList
                    })
                })
            ];

            const [containersResponse] = await Promise.all(requests);

            if (containersResponse.ok){
                const data = await containersResponse.json();
                if (submittedType === "cage" && !Array.isArray(data)) {
                    // Flatten cage response: { "CAGE123": [...], "CAGE456": [...] }
                    const flattened = [];
                    for (const [cageCode, bags] of Object.entries(data)) {
                        for (const bag of bags) {
                            flattened.push({ ...bag, cage_code: cageCode });
                        }
                    }
                    setContainers(flattened);
                } else {
                    setContainers(Array.isArray(data) ? data : [data]);
                }
                setShowModal(false);
            } else {
                const err = await containersResponse.json().catch(() => null);
                setError(err?.error || "Erreur lors du chargement des conteneurs.");
            }
        } catch (err) {
            setError("Erreur lors du chargement des conteneurs.");
        } finally {
            setLoading(false);
        }
    }

        const filteredContainers = containers.filter(
        (container) =>
            container.name
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
            container.container_label_code
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
            container.point_to_code
                ?.toLowerCase()
                .includes(search.toLowerCase()) ||
            container.cage_code
                ?.toLowerCase()
                .includes(search.toLowerCase())
    );

    return (
        <>
        <Modal
            title={"Rechercher"}
            body={
                <>
                    <Field
                        name="date"
                        label="Date"
                        type="date"
                        value={modalDate}
                        onChange={(e) => setModalDate(e.target.value)}
                    />
                    <div className="mb-4">
                        <label className="form-label d-block mb-2">Type</label>
                        <div className="btn-group w-100" role="group">
                            <button type="button" className={`btn ${modalType === "bag" ? "btn-primary" : "btn-light"}`} onClick={() => setModalType("bag")}>
                                <i className="fas fa-bag-shopping me-2"></i>Sac
                            </button>
                            <button type="button" className={`btn ${modalType === "cage" ? "btn-primary" : "btn-light"}`} onClick={() => setModalType("cage")}>
                                <i className="fas fa-boxes-stacked me-2"></i>Cage
                            </button>
                        </div>
                    </div>
                    <TextArea
                        name="containers"
                        label="Conteneur"
                        value={modalContainersInput}
                        onChange={(e) => setModalContainersInput(e.target.value)}
                    />
                </>
            }
            button={{
                close:"Annuler",
                valid:"Valider"
            }}
            showModal={showModal}
            setShowModal={setShowModal}
            onSubmit={handleSubmit}
        />
        <div className="card mb-4">
            <div className="card-header py-3">
                <div className="row py-3">
                    <div className="col-sm-4 text-center text-sm-start">
                        <h5 className="mb-4 mb-sm-0 mt-2">
                            Logistique
                        </h5>
                    </div>
                    <div className="col-sm-8 text-center text-sm-end">
                        {containers.length > 0 && !loading && (
                            <PDFDownloadLink
                                document={<LabelDocument bags={containers} type={type} />}
                                fileName={
                                    "Étiquette du " + moment()
                                        .locale("fr")
                                        .format("ddd Do MMM [à] HH:mm")
                                        .replace(/\.\s?/g, " ")
                                        .trim()
                                }
                                className="btn btn-link me-1"
                                data-mdb-ripple-init
                                data-ripple-color="primary"
                            >
                                {({ loading: pdfLoading }) => pdfLoading ? (
                                    "Création du PDF..."
                                ) : (
                                    <>
                                        Télécharger
                                        <i className="fas fa-download ms-2"></i>
                                    </>
                                )}
                            </PDFDownloadLink>
                        )}
                        {containers.length > 0 && !loading && (
                            <PDFDownloadLink
                                document={<RouteReportDocument containers={containers} type={type} />}
                                fileName={
                                    "Rapport routes du " + moment()
                                        .locale("fr")
                                        .format("ddd Do MMM [à] HH:mm")
                                        .replace(/\.\s?/g, " ")
                                        .trim()
                                }
                                className="btn btn-link me-1"
                                data-mdb-ripple-init
                                data-ripple-color="primary"
                            >
                                {({ loading: pdfLoading }) => pdfLoading ? (
                                    "Création du rapport..."
                                ) : (
                                    <>
                                        Rapport
                                        <i className="fas fa-file-pdf ms-2"></i>
                                    </>
                                )}
                            </PDFDownloadLink>
                        )}
                        <button
                            type="button"
                            className="btn btn-outline-primary me-2"
                            onClick={handleOpenModal}
                        >
                            Rechercher
                            <i className="fas fa-magnifying-glass ms-2"></i>
                        </button>
                    </div>
                </div>
            </div>
            {loading ? (
                <Loading />
            ) : error ? (
                <div className="card-body">
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                </div>
            ) : (containers.length > 0 &&
                <div className="card-body py-5 px-5">
                    <div className="d-flex align-items-center mb-4">
                        <div className="flex-grow-1">
                            <Field
                                name="search"
                                label="Rechercher"
                                value={search}
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                }}
                                type="text"
                                margin={false}
                            />
                        </div>
                    </div>
                    <table className="table table-hover card-body align-middle mb-0 bg-white" id="tableRoutePlanning">
                        <thead className="bg-light">
                            <tr className="center">
                                <th>#</th>
                                {type === "cage" && <th>Cage</th>}
                                <th>Sac</th>
                                <th>Hub</th>
                                <th>Type</th>
                                <th>Point</th>
                                <th>Commerce</th>
                                <th>Adresse</th>
                                <th>Tournée</th>
                            </tr>
                        </thead>
                        <tbody>
                        {filteredContainers.map((container, index) => (
                            <tr className="text-center" key={(container.cage_code || '') + container.container_label_code}>
                                <td>{index + 1}</td>
                                {type === "cage" && <td>{container.cage_code}</td>}
                                <td>{container.container_label_code}</td>
                                <td>{container.destination_hub_code}</td>
                                <td>{TYPE_LABELS[container.point_to_type]}</td>
                                <td>{container.point_to_code}</td>
                                <td>{container.name}</td>
                                <td>
                                    {container.address}{container.address && ', '}{container.city}
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <p className="fw-bold mb-1">
                                                {container.routes?.[0]
                                                    ? container.routes[0].route_name + " #" + container.routes[0].sequence_in_route
                                                    : ""}
                                            </p>
                                            <p className="text-muted mb-0">
                                                {container.routes?.[0]
                                                    ? moment(container.routes[0].scheduled_for)
                                                        .locale("fr")
                                                        .format("ddd Do MMM")
                                                    : ""}
                                            </p>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    </>
    )
}